import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderAR from "../../headerAR/headerar";
import FooterAR from "../../footerAR/footerar";
import './arriskinspectionservices.scss';

const ARRiskInspectionServices = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div className="main-fluid">
     <HeaderAR />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div className="dsk-tab-btn-viewmode-ar">
        <div className="riskinspetserv-tab-imagebannermain-ar">
          <div className="riskinspetserv-banner-con-ar">
            <div className="riskinspetservtab-banne-sec-ar">
              <h1 className="riskinspetserv-banner-heading-ar">خدمات قيمة</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div className="riskinspetserv-tab-btn-ar">
                <div className="riskinspetserv-tab-btn-item-active-ar" onClick={() => window.location.href = "risk-inspection-services-ar"}>خدمات فحص المخاطر </div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "insurance-audits-ar"}>تدقيقات التأمين</div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "valuation-services-ar"}>خدمات التقييم</div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "thermography-testing-insurance-ar"}>اختبار التصوير الحراري</div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "employee-wellness-program-ar"}>برنامج صحة الموظفين</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div className="riskinspetserv-banner-con-ar">
          <div className="riskinspetserv-bdy-ar">
            <div className="riskinspetserv-dflex-en">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div className="riskinspetserv-dlex-rgt-ar">
              <img src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_inspection_services_ar.png"} alt="خدمات فحص المخاطر" />
              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div className="riskinspetserv-dlex-lft-ar">
                <h2 className="pagetitle-ar">خدمات فحص المخاطر</h2>

                <p className="riskinspetserv-pg-txt-con-ar">نحن نسهل استبيانات فحص المخاطر، من منظور الاكتتاب مع التركيز على السلامة وإدارة المخاطر، من خلال مسّاحين ومهندسي مخاطر مهرة. تشمل النقاط البارزة في استبيانات فحص المخاطر الماثلة ما يلي</p>

                <div className="riskinspetserv-keypoint-ar">
                  <div className="riskinspetserv-keypoint-item-ar">تحليل المجالات والأنشطة المعرضة للمخاطر في عمليات عملك</div>

                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div className="riskinspetserv-keypoint-item-ar"> فحص التمديدات الكهربائية، وطفايات الحريق، والتدبير المنزلي، والتكديس، وما إلى ذلك</div>
                  
                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div className="riskinspetserv-keypoint-item-ar"> فحص مستويات الأرض وظروف التربة وقوة الهيكل</div>
                  
                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div className="riskinspetserv-keypoint-item-ar">عمليات التفتيش لمسح الطريق للشحنات ذات الأبعاد الزائدة</div>
                  
                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div className="riskinspetserv-keypoint-item-ar">اقتراح تحسين المخاطر/ تدابير التخفيف من الخسارة</div>
                  
                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div className="riskinspetserv-keypoint-item-ar">جمع المعلومات المتعلقة بالخسائر الكبرى السابقة</div>
                  
                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div className="riskinspetserv-keypoint-item-ar">التفتيش من قبل المهندسين ذوي الخبرة</div>
                  <div className="riskinspetserv-keypoint-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                </div>

                <p className="riskinspetserv-pg-txt-con-ar">نتطلع إلى حماية المخاطر من خلال خدمات فحص المخاطر لدينا، يرجى الاتصال بنا للحصول على مزيد من التفاصيل أو المناقشات حول عروضنا</p>

              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>
            
            <h3 className="riskinspetserv-whykrinsu-title-ar">ما الذي يُميز شركة كيمجي رامداس لخدمات التأمين عن غيرها؟</h3>
            <div className="clearfix"></div>
            
            <div className="riskinspetserv-pins-list-dksp-ar">
              <div className="riskinspetserv-lt-two-dksp-ar">خدمات المطالبات الفورية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
              <div className="riskinspetserv-lt-one-dksp-ar">شروط تنافسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
              <div className="riskinspetserv-lt-two-dksp-ar">أفضل ممارسات صناعة التأمين <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
              <div className="riskinspetserv-lt-one-dksp-ar">مقارنات عروض أسعار واسعة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            </div>


          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* TAB-VIEW AND TABS SECTION STARTS HERE */}
      <div className="tab-btn-viewmode-ar">
        <div className="riskinspetserv-tab-imagebannermain-ar">
          <div className="riskinspetserv-banner-con-ar">
            <div className="riskinspetservtab-banne-sec-ar">
              <h1 className="riskinspetserv-banner-heading-ar">خدمات قيمة</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div className="riskinspetserv-tab-btn-ar">
                <div className="riskinspetserv-tab-btn-item-active-ar" onClick={() => window.location.href = "risk-inspection-services-ar"}>خدمات فحص المخاطر </div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "insurance-audits-ar"}>تدقيقات التأمين</div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "valuation-services-ar"}>خدمات التقييم</div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "thermography-testing-insurance-ar"}>اختبار التصوير الحراري</div>
                <div className="riskinspetserv-tab-btn-item-ar" onClick={() => window.location.href = "employee-wellness-program-ar"}>برنامج صحة الموظفين</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div className="riskinspetserv-banner-con-ar">
          <div className="tab-imgtxt-ar">
            <h2>خدمات فحص المخاطر</h2>
            <div className="tabs-cont-ar">
              <img className="rgt-img-ar" src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_inspection_services_ar.png"} alt="خدمات فحص المخاطر" />
              
              <p>نحن نسهل استبيانات فحص المخاطر، من منظور الاكتتاب مع التركيز على السلامة وإدارة المخاطر، من خلال مسّاحين ومهندسي مخاطر مهرة. تشمل النقاط البارزة في استبيانات فحص المخاطر الماثلة ما يلي</p>

            <div className="tabkyfet-ar">
              <div className="tabkeyfet-txt-ar">تحليل المجالات والأنشطة المعرضة للمخاطر في عمليات عملك</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>

              <div className="tabkeyfet-txt-ar">فحص التمديدات الكهربائية، وطفايات الحريق، والتدبير المنزلي، والتكديس، وما إلى ذلك</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>

              <div className="tabkeyfet-txt-ar">فحص مستويات الأرض وظروف التربة وقوة الهيكل</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>

              <div className="tabkeyfet-txt-ar">عمليات التفتيش لمسح الطريق للشحنات ذات الأبعاد الزائدة</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>

              <div className="tabkeyfet-txt-ar">اقتراح تحسين المخاطر/ تدابير التخفيف من الخسارة</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>

              <div className="tabkeyfet-txt-ar">جمع المعلومات المتعلقة بالخسائر الكبرى السابقة</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>

              <div className="tabkeyfet-txt-ar">التفتيش من قبل المهندسين ذوي الخبرة</div>
              <div className="tabkeyfet-img-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /></div>
              
              </div>

            <p>نتطلع إلى حماية المخاطر من خلال خدمات فحص المخاطر لدينا، يرجى الاتصال بنا للحصول على مزيد من التفاصيل أو المناقشات حول عروضنا</p>
            
            <h3 className="tab-whykrinsu-title-ar">ما الذي يُميز شركة كيمجي رامداس لخدمات التأمين عن غيرها؟</h3>
            
            <div className="tab-whykrinsu-pins-list-ar">
              <div className="tab-whykrinsu-pinlft-two-ar">خدمات المطالبات الفورية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
              <div className="tab-whykrinsu-pinlft-one-ar">شروط تنافسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
              <div className="tab-whykrinsu-pinlft-two-ar">أفضل ممارسات صناعة التأمين <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
              <div className="tab-whykrinsu-pinlft-one-ar">مقارنات عروض أسعار واسعة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            </div>

            </div>
          </div>
          
        </div>
      </div>
      {/* TAB-VIEW AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div className="riskinspetserv-tab-imagebannermain-ar hidden-desktop hidden-md-device hidden-lg">
        <div className="dropdown-sec">
          <select className="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"risk-inspection-services-ar"} selected className="active">خدمات فحص المخاطر </option>
            <option value={"insurance-audits-ar"}>تدقيقات التأمين</option>
            <option value={"valuation-services-ar"}>خدمات التقييم</option>
            <option value={"thermography-testing-insurance-ar"}>اختبار التصوير الحراري</option>
            <option value={"employee-wellness-program-ar"}>برنامج صحة الموظفين</option>
          </select>
        </div>
        <div className="riskinspetserv-mob-main-ar">
          <h1 className="riskinspetserv-banner-heading-ar">خدمات فحص المخاطر</h1>
          <div className="riskinspetserv-mob-img-ar">
            <img src={process.env.PUBLIC_URL + "/riskmanagementservices_images/tab_images/risk_inspection_services_ar.png"} alt="risk inspection services" />
          </div>

          <p className="riskinspetserv-mob-txt-ar">نحن نسهل استبيانات فحص المخاطر، من منظور الاكتتاب مع التركيز على السلامة وإدارة المخاطر، من خلال مسّاحين ومهندسي مخاطر مهرة. تشمل النقاط البارزة في استبيانات فحص المخاطر الماثلة ما يلي:</p>

          <div className="riskinspetserv-pins-list-mob-ar">
            <div className="riskinspetserv-pins-list-mob-item-ar">تحليل المجالات والأنشطة المعرضة للمخاطر في عمليات عملك.</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div className="riskinspetserv-pins-list-mob-item-ar"> فحص التمديدات الكهربائية، وطفايات الحريق، والتدبير المنزلي، والتكديس، وما إلى ذلك.</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div className="riskinspetserv-pins-list-mob-item-ar"> فحص مستويات الأرض وظروف التربة وقوة الهيكل.</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div className="riskinspetserv-pins-list-mob-item-ar">عمليات التفتيش لمسح الطريق للشحنات ذات الأبعاد الزائدة.</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div className="riskinspetserv-pins-list-mob-item-ar">اقتراح تحسين المخاطر/ تدابير التخفيف من الخسارة.</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div className="riskinspetserv-pins-list-mob-item-ar">جمع المعلومات المتعلقة بالخسائر الكبرى السابقة.</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div className="riskinspetserv-pins-list-mob-item-ar">التفتيش من قبل المهندسين ذوي الخبرة</div>
            <div className="riskinspetserv-pins-list-mob-itemimg-ar"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
          </div>

          <p className="riskinspetserv-mob-txt-ar">نتطلع إلى حماية المخاطر من خلال خدمات فحص المخاطر لدينا، يرجى الاتصال بنا للحصول على مزيد من التفاصيل أو المناقشات حول عروضنا. </p>
          
          <h3 className="riskinspetserv-whykrinsu-mob-title-ar">ما الذي يُميز شركة كيمجي رامداس لخدمات التأمين عن غيرها؟</h3>
          
          <div className="riskinspetserv-mob-whykrlist-ar">
            <div className="riskinspetserv-mob-whykrlist-item-ar">شروط تنافسية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            <div className="riskinspetserv-mob-whykrlist-item-ar">خدمات المطالبات الفورية <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            <div className="riskinspetserv-mob-whykrlist-item-ar">مقارنات عروض أسعار واسعة <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
            <div className="riskinspetserv-mob-whykrlist-item-ar">أفضل ممارسات صناعة التأمين <img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> </div>
          </div>

        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterAR />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default ARRiskInspectionServices;
